import React from "react";
import { Users, Mail, Calendar } from "lucide-react";
import StatCard from "./StatCard";

const AdminStats = ({ stats, sourceCounts }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
    <StatCard
      icon={Users}
      label="Real signups"
      value={stats.total}
      hint="Stored in MongoDB"
    />
    <StatCard
      icon={Mail}
      label="Public count (internal)"
      value={stats.displayed_total}
      hint="Reserved for future use; no longer shown on the site"
    />
    <StatCard
      icon={Calendar}
      label="From hero form"
      value={sourceCounts.hero}
    />
    <StatCard
      icon={Calendar}
      label="From final CTA"
      value={sourceCounts.final_cta}
    />
  </div>
);

export default AdminStats;
